import Vue from 'vue';

export default {
  reset(state) {
    state.chats = {};
    state.currentChat = {};
    state.currentChatUsername = null;
  },

  updateChats(state, chats) {
    state.chats = chats;
  },

  updateChat(state, chat) {
    if (state.chats[chat.tempId]) {
      Vue.delete(state.chats, chat.tempId);
    }
    Vue.set(state.chats, chat.id, chat);

    let currentChatId = state.currentChat.id;
    if (currentChatId === chat.id || currentChatId === chat.tempId) {
      state.currentChat = chat;
    }
  },

  updateChatMessages(state, {chatId, tempId, messages, totalCount}) {
    if (!messages || messages.length === 0) {
      return;
    }

    let chat = state.chats[chatId] ? state.chats[chatId] : state.chats[tempId];
    if (!chat) {
      return;
    }

    if (typeof totalCount === 'number') {
      chat.totalChatMessageCount = totalCount;
    }

    // if local chat has no message
    if ( chat.messages.length === 0) {
      chat.messages = messages;
      return;
    }

    // let firstMsgTime = chat.messages[0].timeStamp;
    // let lastMsgTime = chat.messages[chat.messages.length-1].timeStamp;

    // if incoming messages is newer than exists
    // if (messages[0].timeStamp > lastMsgTime) {
    //   chat.messages = chat.messages.concat(messages);
    //   return;
    // }

    // if incoming messages is older than exists
    // if (messages[messages.length-1].timeStamp < firstMsgTime) {
    //   chat.messages = messages.concat(chat.messages);
    //   return;
    // }

    // if time range of incoming messages is crossed with current messages.
    let msgMap = new Map();
    chat.messages.forEach(m => msgMap.set(m.id, m));
    messages.forEach(m => msgMap.set(m.id, m));
    chat.messages = Array.from(msgMap.values()).sort((a, b) => {
      return a.timeStamp - b.timeStamp;
    });
  },

  updateChatReadCount(state, {chatId, username, readCount}) {
    let chat = state.chats[chatId];
    if (!chat) {
      return;
    }

    // NOTE:
    // currently Vue doesn't support observation for Map or Set data type.
    // The easy way to use Map or Set with observation is to clone it and replace old.
    let participantReadCounts = new Map();
    Array.from(chat.participantReadCounts.entries()).forEach(entry => {
      participantReadCounts.set(entry[0], entry[1]);
    });

    participantReadCounts.set(username, readCount);
    chat.participantReadCounts = participantReadCounts;
    // Vue.set(chat, 'participantReadCounts', participantReadCounts);
  },

  updateCurrentChat(state, {chatDto = {}, username}) {
    state.currentChat = chatDto;
    state.currentChatUsername = username;
  }
};
